/**
 * 删除url参数
 * @param {string} url 地址
 * @param {string} arg 参数名
 * @returns {string}
 */
export function deleteURLArg(url, arg) {
    var urlArr = url.split('?')
    if (urlArr.length > 1 && urlArr[1].indexOf(arg) > -1) {
        var query = urlArr[1]
        var obj = {}
        var arr = query.split('&')
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=')
            obj[arr[i][0]] = arr[i][1]
        }
        delete obj[arg]
        const args_str = JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
        var urlte
        if (args_str) {
            urlte = urlArr[0] + '?' + args_str
        } else {
            // 没有参数时 去掉 ?
            urlte = urlArr[0]
        }
        return urlte
    } else {
        return url
    }
}